import request from '@/utils/request'

export function refreshAll() {
    return request({
        url: '/socket/refreshAll',
        method: 'post',
    })
}

export function getTemplate(params) {
    return request({
        url: '/socket/getTemplate',
        method: 'get',
        params: params
    })
}

export function competitionList(params) {
    return request({
        url: '/socket/getCompetitionList',
        method: 'get',
        params: params
    })
}
